module.exports = __webpack_public_path__ + "img/bilibili.ae30d32f.svg";